export var updateUrlSid = function (url, quickQuoteType) {
    return url.replace(/\s/g, '').replace('brochure', quickQuoteType);
};
